module.exports = __webpack_public_path__ + "static/media/ic_calendar.0c4262b9.svg";